export default class DependentsApplication {
  addAnotherDependentListeners() {
    const dependentSelector = '[data-behaviour="dependent"]';
    const $addDependentsButton = $('[data-behaviour="add_dependent"]');

    $addDependentsButton.click(() => $(`${dependentSelector}:hidden:first`).show());
  }

  init() {
    if ($('.dependents').length) {
      this.addAnotherDependentListeners();
    }
  }
}
